import type { RouteRecordRaw } from 'vue-router';

import ordersListRoute from './list';
import ordersDetailsRoute from './details';

export default [ordersListRoute, ordersDetailsRoute] as RouteRecordRaw[];
